const STORAGE_KEY = 'punchlines-admin-hint';

// Mémorise le dernier statut admin connu pour un affichage optimiste au
// chargement (Dashboard/Déconnecter visibles immédiatement au lieu de
// clignoter le temps de la vraie vérification serveur). Purement cosmétique :
// le statut réel renvoyé par /api/admin/session reste toujours la source de
// vérité et corrige l'affichage si ce cache est faux ou périmé.

export function getCachedIsAdmin() {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function setCachedIsAdmin(isAdmin) {
  try {
    localStorage.setItem(STORAGE_KEY, isAdmin ? '1' : '0');
  } catch {
    // Stockage indisponible (navigation privée, quota) : pas de cache optimiste.
  }
}
